import * as wasm from "./kit_interpolation_bg.wasm";
export * from "./kit_interpolation_bg.js";
import { __wbg_set_wasm } from "./kit_interpolation_bg.js";
__wbg_set_wasm(wasm);
wasm.__wbindgen_start();
